import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import setting from './modules/setting'
import file from './modules/file'
import searchData from './modules/searchData'
import queryCriteria from './modules/queryCriteria'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account,
    setting,
    file,
    searchData,
    queryCriteria
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js